module.exports = __webpack_public_path__ + "media/images/photos/photo-19-0d2a880951ce02238bd757f65b64d9cf.jpg";